var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoldersFolderOpenStyle2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 30.0565V24C56 21.0545 53.6122 18.6667 50.6667 18.6667H33.52C32.6373 18.6667 31.8118 18.2298 31.3153 17.5L27.4597 11.8334C26.9631 11.1035 26.1376 10.6666 25.2548 10.6667H13.3333C10.3878 10.6667 8 13.0545 8 16V49.1118C8 51.4433 9.89005 53.3333 12.2215 53.3333V53.3333C14.3726 53.3333 16.1797 51.7159 16.4173 49.578L18.1395 34.0777C18.4396 31.3767 20.7226 29.3333 23.4402 29.3333H53.3327C54.8497 29.3333 56.295 29.9794 57.3067 31.1097C58.3185 32.2401 58.8009 33.7479 58.6334 35.2556L57.1519 48.5889C56.8518 51.2899 54.5688 53.3333 51.8512 53.3333H12.2215",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoldersFolderOpenStyle2);
export default ForwardRef;